const amountOfLettersForSingleName = 3;

const getUserInitials = <T extends { firstName?: string; lastName?: string; }>(
  obj: T,
  startFromLastName?: boolean,
) => {
  if (obj.firstName && obj.lastName) {
    if (startFromLastName) {
      return `${obj.lastName[0]}${obj.firstName[0]}`.toLocaleUpperCase();
    }
    return `${obj.firstName[0]}${obj.lastName[0]}`.toLocaleUpperCase();
  }

  if (obj.firstName) {
    return obj.firstName.substring(0, amountOfLettersForSingleName);
  }

  if (obj.lastName) {
    return obj.lastName.substring(0, amountOfLettersForSingleName);
  }

  return undefined;
};

export default getUserInitials;
